import React from 'react';
// can be used to disable lazy loading for an entire subtree
const LazyImageContext = /*#__PURE__*/ React.createContext(false);
LazyImageContext.displayName = 'LazyImageContext';
export default LazyImageContext;

//# sourceMappingURL=LazyImageContext.js.map